import { WidgetProps } from '@rjsf/core';

export const defaultProps: WidgetProps = {
    name: '',
    options: {
        enumOptions: false,
    },
    schema: {
        title: 'title',
        type: 'string',
    },
    uiSchema: {
        'ui:widget': 'widget',
    },
    id: '',
    label: '',
    value: '',
    required: false,
    disabled: false,
    readonly: false,
    formContext: {},
    autofocus: false,
    multiple: false,
    placeholder: '',
    registry: {
        fields: {},
        widgets: {},
        definitions: {},
        rootSchema: {
            title: 'Title',
            type: 'object',
            required: [],
            properties: {},
        },
        formContext: {},
    },
    onChange: () => {},
    onBlur: () => {},
    onFocus: () => {},
    rawErrors: [],
};

export const rgbToHex = (r: number, g: number, b: number) =>
    `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;

export const hexToRgb = (hex: string) => {
    const values = hex ? /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex) : [];
    return (
        values && {
            r: parseInt(values[1], 16),
            g: parseInt(values[2], 16),
            b: parseInt(values[3], 16),
        }
    );
};

export const resizeSidebar = () => {
    // Check if any sidebar tabs are actually open before manipulating app width
    const rightSideBar = document.getElementById('right-side-bar-main');
    if (!rightSideBar || rightSideBar.offsetWidth === 0) {
        // No sidebar is open, don't manipulate app width
        return;
    }

    document.getElementById('right-side-bar-main')?.style.setProperty('max-width', '700px');
    const rigthSidebarElem = document.querySelector<HTMLElement>('.right-sidebar-tool');
    rigthSidebarElem?.style?.setProperty('width', '100%');
    document.getElementById('right-side-bar-main')?.style.setProperty('width', '550px');
    const rjsfElem = document.querySelector<HTMLElement>('.rjsf');
    const width = rjsfElem?.offsetWidth || 0;
    if (width > 550) {
        rigthSidebarElem?.style?.setProperty('width', `${width}px`);
    }
    
    // Don't manipulate app width here - let RightSideBar component handle this
    // This function should only handle the internal sidebar content sizing
    // The app width manipulation will be handled by the RightSideBar useEffect
    
    const toolelement = document.querySelector<HTMLElement>('.right-sidebar-tool');
    toolelement && toolelement!.style.setProperty('width', `${550 - 10}px`);
};
